/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { AllegatoDaCopiare } from './allegato-da-copiare';


export interface PraticaEsercentePerContoForm { 
    profilo_esercente_id: string;
    form_data?: { [key: string]: any; };
    negozi_ids?: Array<string>;
    da_pratica_esercente_id?: string;
    allegati_da_copiare?: Array<AllegatoDaCopiare>;
}

